var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDateIconOne(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_33)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 1.12475H9.375V0.374747C9.37507 0.27529 9.33562 0.179881 9.26534 0.109508C9.19506 0.0391353 9.09971 -0.000437147 9.00025 -0.000503451C8.90079 -0.000569755 8.80539 0.0388755 8.73501 0.109155C8.66464 0.179434 8.62507 0.27479 8.625 0.374247V1.12475H6.375V0.374747C6.37503 0.325501 6.36537 0.276731 6.34655 0.231221C6.32774 0.185712 6.30014 0.144353 6.26534 0.109508C6.23054 0.0746631 6.18922 0.0470132 6.14374 0.0281374C6.09825 0.00926154 6.0495 -0.000470626 6.00025 -0.000503457C5.90079 -0.000569761 5.80538 0.0388755 5.73501 0.109155C5.66464 0.179434 5.62507 0.27479 5.625 0.374247V1.12475H3.375V0.374747C3.37503 0.325501 3.36537 0.276731 3.34655 0.231221C3.32774 0.185712 3.30014 0.144353 3.26534 0.109508C3.23054 0.0746631 3.18922 0.0470132 3.14374 0.0281374C3.09825 0.00926154 3.0495 -0.000470626 3.00025 -0.000503457C2.90079 -0.000569761 2.80538 0.0388755 2.73501 0.109155C2.66464 0.179434 2.62507 0.27479 2.625 0.374247V1.12475H1C0.73487 1.12475 0.480592 1.23003 0.29307 1.41746C0.105548 1.60489 0.000132565 1.85912 0 2.12425V10.9992C0 11.2645 0.105357 11.5188 0.292893 11.7064C0.48043 11.8939 0.734784 11.9992 1 11.9992H11C11.2652 11.9992 11.5196 11.8939 11.7071 11.7064C11.8946 11.5188 12 11.2645 12 10.9992V2.12425C11.9999 1.85912 11.8945 1.60489 11.7069 1.41746C11.5194 1.23003 11.2651 1.12475 11 1.12475V1.12475ZM11.25 10.9997C11.25 11.066 11.2237 11.1295 11.177 11.1763C11.1302 11.2232 11.0667 11.2496 11.0005 11.2497H1C0.933696 11.2497 0.870107 11.2234 0.823223 11.1765C0.776339 11.1296 0.75 11.0661 0.75 10.9997V2.12475C0.750132 2.05853 0.77653 1.99507 0.8234 1.94829C0.87027 1.90152 0.933782 1.87525 1 1.87525H2.625V2.62525C2.62493 2.7247 2.66438 2.82011 2.73466 2.89048C2.80494 2.96086 2.90029 3.00043 2.99975 3.0005C3.09921 3.00056 3.19462 2.96112 3.26499 2.89084C3.33536 2.82056 3.37493 2.7252 3.375 2.62575V1.87525H5.625V2.62525C5.62493 2.7247 5.66438 2.82011 5.73466 2.89048C5.80494 2.96086 5.90029 3.00043 5.99975 3.0005C6.09921 3.00056 6.19462 2.96112 6.26499 2.89084C6.33536 2.82056 6.37493 2.7252 6.375 2.62575V1.87525H8.625V2.62525C8.62493 2.7247 8.66438 2.82011 8.73466 2.89048C8.80494 2.96086 8.90029 3.00043 8.99975 3.0005C9.09921 3.00056 9.19461 2.96112 9.26499 2.89084C9.33536 2.82056 9.37493 2.7252 9.375 2.62575V1.87525H11C11.0661 1.87538 11.1295 1.90171 11.1763 1.94847C11.223 1.99523 11.2494 2.05862 11.2495 2.12475L11.25 10.9997Z",
    fill: "#A1A1A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.625 4.5H4.125V5.625H2.625V4.5Z",
    fill: "#A1A1A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.625 6.375H4.125V7.5H2.625V6.375Z",
    fill: "#A1A1A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.625 8.25H4.125V9.375H2.625V8.25Z",
    fill: "#A1A1A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.25 8.25H6.75V9.375H5.25V8.25Z",
    fill: "#A1A1A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.25 6.375H6.75V7.5H5.25V6.375Z",
    fill: "#A1A1A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.25 4.5H6.75V5.625H5.25V4.5Z",
    fill: "#A1A1A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.875 8.25H9.375V9.375H7.875V8.25Z",
    fill: "#A1A1A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.875 6.375H9.375V7.5H7.875V6.375Z",
    fill: "#A1A1A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.875 4.5H9.375V5.625H7.875V4.5Z",
    fill: "#A1A1A1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_33"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDateIconOne);
export default __webpack_public_path__ + "static/media/date_icon_one.6b9f65bb.svg";
export { ForwardRef as ReactComponent };